import { Card, CardContent, CardHeader } from '@/components/ui/card';
import styles from './cardSummary.module.css';
import clsx from 'clsx';

const CardSummary = ({
  onClick,
  isActive,
  className,
  title,
  icon,
  value,
  description,
  showContent = true,
}) => {
  return (
    <Card
      onClick={onClick}
      className={`tw-flex-1 sm:tw-w-56 tw-overflow-hidden hover:tw-shadow-md tw-cursor-pointer tw-p-[11px] ${
        isActive
          ? clsx(styles.isActive, 'tw-border-[1px] tw-border-[#675dff]')
          : 'tw-border tw-border-gray-300'
      } ${className}`}
    >
      <CardHeader className='flex flex-row tw-items-center tw-justify-between p-0'>
        <div
          className={`tw-text-sm ${
            isActive ? 'tw-text-[#675dff] tw-font-semibold' : 'tw-font-light'
          }`}
        >
          {title}
        </div>
        <div className={isActive ? 'tw-text-[#675dff] mt-0' : 'w-text-gray-500 mt-0'}> {icon}</div>
       
      </CardHeader>
      {showContent && (
        <CardContent className='flex flex-row p-0 mt-1'>
          <div
            className={`tw-text-base tw-font-semibold tw-leading-[20px] ${
              isActive && 'tw-text-[#675dff]'
            }`}
          >
            {value}
          </div>
          {description && (
            <p className='tw-text-xs tw-font-medium tw-text-gray-500'>{description}</p>
          )}
        </CardContent>
      )}
    </Card>
  );
};

export default CardSummary;
